import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESCHANNEL,
  DELETE_SALESCHANNEL,
  UPDATE_SALESCHANNEL,
  ADD_NEW_SALESCHANNEL,
} from "./actionType";

import {
  getSalesChannelSuccess,
  getSalesChannelFail,
  deleteSalesChannelSuccess,
  deleteSalesChannelFail,
  updateSalesChannelSuccess,
  updateSalesChannelFail,
  addSalesChannelSuccess,
  addSalesChannelFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesChannelApi,
  getSalesChannelApi,
  updateSalesChannelApi,
  deleteSalesChannelApi,
  addNewSalesChannelApi
} from "../../helpers/backend_helper";

function* getSalesChannel({ payload: salesChannel }) {
  try {
    const response = yield call(getSalesChannelApi, salesChannel);
    yield put(getSalesChannelSuccess(GET_SALESCHANNEL, response.data));
  } catch (error) {
    yield put(getSalesChannelFail(GET_SALESCHANNEL, error));
  }
}

function* onUpdateSalesChannel({ payload: salesChannel }) {
  try {
    if (salesChannel.setApprove) {
      const response = yield call(approveSalesChannelApi, salesChannel);
      yield put(updateSalesChannelSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesChannelApi, salesChannel);
      yield put(updateSalesChannelSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesChannelFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesChannel({ payload: salesChannel }) {
  try {
    const response = yield call(deleteSalesChannelApi, salesChannel);
    yield put(deleteSalesChannelSuccess({ salesChannel, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesChannelFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesChannel({ payload: salesChannel }) {
  try {
    const response = yield call(addNewSalesChannelApi, salesChannel);
    yield put(addSalesChannelSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesChannelFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesChannel() {
  yield takeEvery(GET_SALESCHANNEL, getSalesChannel);
}

export function* watchUpdateSalesChannel() {
  yield takeEvery(UPDATE_SALESCHANNEL, onUpdateSalesChannel);
}

export function* watchDeleteSalesChannel() {
  yield takeEvery(DELETE_SALESCHANNEL, onDeleteSalesChannel);
}

export function* watchAddNewSalesChannel() {
  yield takeEvery(ADD_NEW_SALESCHANNEL, onAddNewSalesChannel);
}

function* salesChannelSaga() {
  yield all([
    fork(watchGetSalesChannel),
    fork(watchDeleteSalesChannel),
    fork(watchUpdateSalesChannel),
    fork(watchAddNewSalesChannel)
  ]);
}

export default salesChannelSaga;
